<script>
export default {
  name: "VideoHaikuboxOverview.vue",
  beforeCreate() {
    // Redirect to a different webpage
    window.location.href = "https://youtu.be/8bEdAY1Z1hQ";
  },
};
</script>
